import React from 'react'

function Sells() {
  return (
    <div>Sells</div>
  )
}

export default Sells